import { Stack, Text } from '@mantine/core';

function AdminPage() {
  console.log('###### import.meta.env:', import.meta.env);
  return (
    <Stack>
      <Text>Admin Page</Text>
      <Text>BRANCH: {import.meta.env.BRANCH}</Text>
      <Text>COMMIT_HASH: {import.meta.env.COMMIT_HASH}</Text>
      <Text>MODE: {import.meta.env.MODE}</Text>
      <Text>ENV: {import.meta.env.ENV}</Text>
      <Text>PROD: {import.meta.env.PROD.toString()}</Text>
      <Text>DEV: {import.meta.env.DEV.toString()}</Text>
    </Stack>
  );
}

export default AdminPage;
